import SEO from "../../components/SEO";
import Header from "../../components/Header";
import Breadcrumbs from "../../components/Breadcrumbs";
import Footer from "../../components/Footer";
import Section from "../../components/Section";

// PRZYJAZNEDEKLARACJE
import PrzyjazneDeklaracjaPL from "../../content/przyjaznedeklaracje/deklaracja-dostepnosci/deklaracja-dostepnosci_pl.mdx";

export default function KontaktLayout(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "deklaracja";

	return (
		<>
			{/* HEAD */}
			<SEO miasto={Miasto} podatek={Podatek} />

			{/* TOP */}

			<Header miasto={Miasto} />

			<Breadcrumbs miasto={Miasto} layout="light" />

			{/* SECTION */}

			<Section mdx titleLeft>
				<PrzyjazneDeklaracjaPL />
			</Section>

			{/* BOTTOM */}

			<Footer miasto={Miasto} />
		</>
	);
}
